<body class="ltr main-body leftmenu">
    <form autocomplete="off" [formGroup]='studentDataForm' novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/FacultyMaster.png"
                                                    class="mh-45px pb-2">
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                            Old Student Data
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        Old Student Data
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Search</mat-label>
                                                <input matInput placeholder="Enter PRN or Student ID" #searchInput
                                                    (keyup.enter)="searchStudent(searchInput.value)">
                                                <mat-icon matSuffix
                                                    (click)="searchStudent(searchInput.value)">search</mat-icon>
                                            </mat-form-field>
                                        </div>

                                    </div>
                                    <hr class="mt-2">
                                    <div class="table-responsive table-container">
                                        <table appShortTable id="datatable"
                                            class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th width="10%" class="f600 ">
                                                        Rg. No.
                                                    </th>
                                                    <th width="30%" class="f600">
                                                        Name
                                                    </th>
                                                    <th width="10%" class="f600 text-center">
                                                        View
                                                    </th>
                                                    <th width="10%" class="f600 text-center">
                                                        Upload Photo & Sign
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let student of studentDataList">
                                                    <td>{{student.StuRgNo}}</td>
                                                    <td>{{student.FullName}}</td>
                                                    <td class="text-center">
                                                        <a style="color: blue;"
                                                            (click)="updatePhotoSign(student,'view')">
                                                            View
                                                        </a>
                                                    </td>
                                                    <td class="text-center">
                                                        <a class="floating mr-2 pr-3" title="Edit"
                                                            (click)="updatePhotoSign(student,'edit')"> <i
                                                                class="fa fa-edit "></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event)"></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>